/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Affects_SpellcheckInputs */

const en_cl_affects_spellcheck = /** @type {(inputs: Cl_Affects_SpellcheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spellcheck while someone types in this product.`)
};

const de_cl_affects_spellcheck = /** @type {(inputs: Cl_Affects_SpellcheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rechtschreibprüfung beim Schreiben in diesem Produkt.`)
};

/**
* | output |
* | --- |
* | "Spellcheck while someone types in this product." |
*
* @param {Cl_Affects_SpellcheckInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_affects_spellcheck = /** @type {((inputs?: Cl_Affects_SpellcheckInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Affects_SpellcheckInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_affects_spellcheck(inputs)
	return en_cl_affects_spellcheck(inputs)
});